import React, { useEffect, useState } from 'react';
import { Button } from './index';
import { theme } from '../config/theme';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const KEY = 'aiDiary.cookie.notice.v1';

  useEffect(() => {
    try {
      const seen = localStorage.getItem(KEY);
      if (seen) {
        setVisible(false);
        return;
      }

      // Backward compatibility: if user already interacted with the old banner,
      // consider the notice acknowledged.
      const legacyPrefs = localStorage.getItem('aiDiary.cookie.prefs.v1');
      const legacyChoice = localStorage.getItem('aiDiary.cookie.choice.v1');
      if (legacyPrefs || legacyChoice) {
        try { localStorage.setItem(KEY, '1'); } catch {}
        setVisible(false);
        return;
      }

      setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const acknowledge = () => {
    try { localStorage.setItem(KEY, '1'); } catch {}
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50">
      <div className="mx-auto max-w-5xl m-3 p-3 rounded-lg shadow-lg" style={{ background: theme.bgCard, color: theme.text, border: `1px solid ${theme.border}` }}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="text-sm" style={{ color: theme.textSoft }}>
            Мы используем cookies, чтобы сайт работал и становился лучше. Управлять cookies можно в настройках браузера.{" "}
            <a href="/privacy" className="underline" target="_blank" rel="noopener noreferrer">Политика обработки персональных данных</a>.
          </div>
          <div className="flex gap-2">
            <Button size="md" variant="primary" onClick={acknowledge}>Понятно</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;


